module.exports = __webpack_public_path__ + "img/logo.c01d159b.svg";